import { createFileRoute } from '@tanstack/react-router';

import { z } from 'zod';
import { zodSearchValidator } from '@tanstack/router-zod-adapter';

import { trpc } from '@web/lib/trpc';

import { PublicPaymentSuccess } from '@web/payments/views';

const searchSchema = z.object({
  token: z.string().catch(''),
});

export const Route = createFileRoute('/payment-success/')({
  validateSearch: zodSearchValidator(searchSchema),
  component: View,
});

function View() {
  const { token } = Route.useSearch();

  const { data: successPaymentDetails } =
    trpc.payment.getSuccessPaymentDetails.useQuery({
      internalPaymentToken: token,
    });

  if (!successPaymentDetails) return null;

  const formattedPaymentDetails = {
    paymentId: successPaymentDetails.paymentId,
    amount: successPaymentDetails.previousPayments[0]?.amount
      ? parseFloat(successPaymentDetails.previousPayments[0].amount)
      : 0,
    totalPaid: successPaymentDetails.totalPaid,
    contractValue: successPaymentDetails.contractValue ?? 0,
    previousPayments: successPaymentDetails.previousPayments.map((payment) => ({
      date: payment.date, // Changed from createdAt to date and using Date object instead of string
      paymentId: payment.paymentId,
      amount: parseFloat(payment.amount),
    })),
  };

  return (
    <div className="grid h-screen items-center justify-center">
      <PublicPaymentSuccess
        internalPaymentToken={token}
        defaultValues={formattedPaymentDetails}
      />
    </div>
  );
}
